import { companyInfo } from '../data/data'

// Strip non-digits, keeping the leading + as per WhatsApp wa.me requirements
const sanitizePhone = (phone) => phone.replace(/[^\d]/g, '')

export const buildWhatsAppCheckoutUrl = (cart) => {
    const phone = sanitizePhone(companyInfo.whatsapp)

    if (!cart || cart.length === 0) {
        const empty = `Bonjour SaDEAP,%0AJe souhaite passer une commande.`
        return `https://wa.me/${phone}?text=${empty}`
    }

    const lines = []
    lines.push(`*Nouvelle commande SaDEAP*`)
    lines.push(``)
    lines.push(`Bonjour, je souhaite commander les produits suivants :`)
    lines.push(``)

    cart.forEach((item, idx) => {
        lines.push(`${idx + 1}. *${item.name}* — Quantité : ${item.quantity}`)
        if (item.categoryName) {
            lines.push(`   Catégorie : ${item.categoryName}`)
        }
    })

    const totalItems = cart.reduce((sum, item) => sum + item.quantity, 0)
    lines.push(``)
    lines.push(`Total articles : *${totalItems}*`)
    lines.push(``)
    lines.push(`Merci de me confirmer la disponibilité et le prix total.`)

    const message = encodeURIComponent(lines.join('\n'))
    return `https://wa.me/${phone}?text=${message}`
}
